import { render, staticRenderFns } from "./ErstelleBusinessUnit.vue?vue&type=template&id=50d9710c&"
import script from "./ErstelleBusinessUnit.vue?vue&type=script&lang=js&"
export * from "./ErstelleBusinessUnit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports